import { useContext } from "react";
import { GlobalAppStoreContext } from "./GlobalAppStoreProvider";

export const useGlobalAppStore = () => {
  const globalAppStoreContext = useContext(GlobalAppStoreContext);

  if (!globalAppStoreContext) {
    throw new Error("useGlobalAppStore must be used within a GlobalAppStoreProvider");
  }

  return globalAppStoreContext;
};
